
export const getStarsNumberOrString = (number, additionalRatings) => {
   if (additionalRatings && additionalRatings !== 'reviews.additionalRatings')
      return additionalRatings
   return number || '4,8'
}

export const getRewievsComments = (number, text) => {
   return `${number} ${text !== 'sub_header.titleComments' ? text : 'reviews'}`
   // return `${number} ${text}`
}

export function getIsArabicLayoutDirection() {
   return !!window.isArabicLayoutDirection
}


const arabicStyles = `
.grid-container-RTL {
   direction: rtl;
}
.RTL{
   direction: rtl;
}
.about_full--item{
   flex-direction: row-reverse !important;
}
.block__app_info--inner_slide{
   direction: rtl;
}
.button-container__button-to{
   transform: rotate(180deg);
}
.rating_block{
   direction: rtl;
}
.title-container{
   direction: rtl;
}
.block__app_info--item_common:not(:last-child)::before {
   background-color: var(--data_color_additional_text);
   content: "";
   display: block;
   height: 24px;
   left: 0;
   position: absolute;
   top: calc(50% - 12px);
   width: 1px;
}
.commentContainer{
   direction: rtl;
}
.message_container__liked{
   // flex-direction: row-reverse;
}
.message_container_RTL{
   direction: rtl;
}
.RTL-end {
	justify-content: flex-end !important;
}

.RTL-flex-direction {
	flex-direction: row-reverse !important;
}

.RTL-align-end {
	align-items: flex-end !important;
}
`;

const commonStyles = `
.block__app_info--item_common:not(:first-child)::before {
   background-color: var(--data_color_additional_text);
   content: "";
   display: block;
   height: 24px;
   left: 0;
   position: absolute;
   top: calc(50% - 12px);
   width: 1px;
}
`;


export function applyArabicDirectionStyles(isOn_income = undefined) {
   let styleTag = document.getElementById('css_arabic_direction');
   const isOn = isOn_income === undefined ? getIsArabicLayoutDirection() : isOn_income

   let styles = commonStyles
   if (isOn)
      styles = arabicStyles

   if (styleTag) {
      styleTag.innerHTML = styles;
   } else {
      styleTag = document.createElement('style');
      styleTag.type = 'text/css';
      styleTag.id = 'css_arabic_direction';
      styleTag.innerHTML = styles;
      document.head.appendChild(styleTag);
   }
}

window.applyArabicDirectionStyles = applyArabicDirectionStyles

applyArabicDirectionStyles(getIsArabicLayoutDirection())
